import { useEffect } from 'react';

import { removePageTitle, setPageTitle } from './PageTitleOverride';

export const useSetPageTitle = (title: string): void => {
    useEffect(() => {
        setPageTitle(title);

        return () => removePageTitle();
    }, [title]);
};
